import Auth from '@javascript/lib/auth';

(function () {
  if (!window.authOptions) return;

  new Auth().initializeAuthClient(window.authOptions).then(async (client) => {
    await client.checkSSOLogin();
  });
})();
